import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import Heading from 'components/Luxkit/Typography/Heading'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'

const Root = styled.div`
  max-width: 100%;
`

const LocationLink = styled(ClickableLink)`
  background: ${props => props.theme.palette.neutral.default.eight};
  width: 100%;
  min-width: ${rem(200)};
  width: ${rem(220)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  ${mediaQueryUp.tablet} {
    width: ${rem(366)};
  }
`

const LocationName = styled(Heading)`
  padding: ${rem(20)} 0;
`

const locations = [{
  name: 'Bali',
  image: 'hx3vgckxkcrtwzwvbqfs',
  url: '/hotels/location/bali/indonesia',
}, {
  name: 'Maldives',
  image: 'rxi3o9jzsiwju5o44tne',
  url: '/hotels/country/maldives',
}, {
  name: 'Thailand',
  image: 'nbex3gjaeq2df9re8641',
  url: '/hotels/country/thailand',
}]

function ReferralTopLocations() {
  return (
    <Root>
      <CardCarousel pageSize={3}>
        {locations.map(item => (
          <LocationLink to={item.url} key={item.name}>
            <ImageWithReservedSpace
              mobileWidth="220px"
              tabletWidth="473px"
              alt={item.name}
              id={item.image}
              gravity="center"
              mobileAspectRatio="1.1"
              tabletAspectRatio="1.85"
            />
            <LocationName variant="heading5" align="center">
              {item.name}
            </LocationName>
          </LocationLink>
        ))}
      </CardCarousel>
    </Root>
  )
}

export default ReferralTopLocations
